import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import Button from 'chameleon/packages/blue-book-player/library/button';
import Icon from 'chameleon/packages/blue-book-player/library/icon';
import log from 'chameleon/packages/blue-book-player/utility/log';
import useLocalStorage from 'chameleon/packages/blue-book-player/hooks/use-local-storage';

const QuestionsReview = (props) => {
  const [markedQuestions, setMarkedQuestions] = useState([]);

  const {
    questions,
    currentQuestionIndex,
    isCompact,
    itemGoTo,
    params,
    userId,
  } = props;
  const assignmentId = params?.assignmentId;

  const [, , getItem] = useLocalStorage({
    key: 'qnMark',
    itemKey: `${userId}-${assignmentId}`,
  });

  const getMarkedQuestions = () => {
    try {
      return JSON.parse(getItem() ?? '[]');
    } catch (error) {
      log('error', error);
      return [];
    }
  };

  useEffect(() => {
    const localStorageMarkedQuestions = getMarkedQuestions();
    setMarkedQuestions(localStorageMarkedQuestions);
  }, []);

  return (
    <div className="flex flex-row flex-wrap bb-mobile:justify-center">
      {questions.map((question, index) => {
        const answerLabel = question?.isAnswered ? 'answered' : 'unanswered';
        const markedLabel = markedQuestions.includes(question?.id)
          ? 'marked for review'
          : '';
        const currentLabel =
          isCompact && currentQuestionIndex === index ? 'current' : '';
        const buttonAccessibility = {
          'aria-label': `${answerLabel} ${markedLabel} question ${index + 1} ${currentLabel}`,
        };
        return (
          <div
            key={question?.id}
            className={cn('box-content relative', {
              'p-[16px]': !isCompact,
              'pt-[16px] px-[8px] pb-[8px]': isCompact,
            })}
          >
            <Button
              size="custom"
              isRounded={false}
              className={cn(
                'flex items-center !font-bold justify-center focus:underline p-0 navigator-jump-button',
                {
                  'bg-white border border-dashed border-black text-bluebook-blue hover:bg-bluebook-light-gray':
                    !question?.isAnswered,
                  'bg-bluebook-blue text-white border-0': question?.isAnswered,
                  'text-[24px] h-[40px] w-[40px]': !isCompact,
                  'text-[19px] h-[29px] w-[29px]': isCompact,
                },
              )}
              accessibility={buttonAccessibility}
              onClick={() => itemGoTo(question?.id)}
            >
              {index + 1}
            </Button>
            {isCompact && currentQuestionIndex === index && (
              <Icon
                id="current_question"
                className={cn('absolute top-0 left-[16px]')}
              />
            )}
            {markedQuestions.includes(question?.id) && (
              <Icon
                id="for_review"
                width={18}
                height={18}
                className={cn(
                  'absolute top-[8px]  bg-white border-[4px] border-white rounded-[4px]',
                  {
                    'left-[29px]': isCompact,
                    'left-[48px]': !isCompact,
                  },
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

QuestionsReview.propTypes = {
  questions: PropTypes.array.isRequired,
  currentQuestionIndex: PropTypes.number,
  isCompact: PropTypes.bool,
  itemGoTo: PropTypes.func,
};

QuestionsReview.defaultProps = {
  currentQuestionIndex: -1,
  isCompact: false,
  itemGoTo: () => {},
};

const mapStateToProps = (state) => ({
  userId: state?.userData?.me?.initId,
});

QuestionsReview.propTypes = {};

export default compose(withRouter, connect(mapStateToProps))(QuestionsReview);
